export const crmTypes = {
  SALESFORCE: 'Salesforce',
  HUBSPOT: 'Hubspot',
  DYNAMICS: 'Dynamics',
};

export const crmTypesToStringMap = {
  [crmTypes.SALESFORCE]: 'Salesforce Push',
  [crmTypes.HUBSPOT]: 'HubSpot Push',
  [crmTypes.DYNAMICS]: 'Dynamics Push',
};
